import { CalendarDays, Flag } from "lucide-react";
import { format, isBefore, isToday, parseISO, startOfToday } from "date-fns";

export const PRIORITY = {
  low: { label: "Low", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  medium: { label: "Medium", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  high: { label: "High", cls: "bg-red-50 text-red-700 border-red-200" },
};

export function PriorityBadge({ priority, testid }) {
  const p = PRIORITY[priority || "medium"];
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium rounded-full border px-2 py-0.5 ${p.cls}`} data-testid={testid}>
      <Flag className="h-3 w-3" /> {p.label}
    </span>
  );
}

export function DueBadge({ due, done, testid }) {
  if (!due) return null;
  const d = parseISO(due);
  const overdue = !done && isBefore(d, startOfToday());
  const today = !done && isToday(d);
  const cls = overdue
    ? "bg-red-100 text-red-700 border-red-300"
    : today
    ? "bg-amber-50 text-amber-700 border-amber-200"
    : "bg-slate-50 text-slate-600 border-slate-200";
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium rounded-full border px-2 py-0.5 ${cls}`} data-testid={testid}>
      <CalendarDays className="h-3 w-3" />
      {overdue ? "Overdue · " : today ? "Today · " : ""}
      {format(d, "d MMM yyyy")}
    </span>
  );
}
